module.exports = __webpack_public_path__ + "f970262b34902ea073a2dac1e2ce039f.svg";